import { useEffect, useState } from "react";

export const useProfileImageState = (
  user: {
    name: string | undefined;
    profile_image_url: string | undefined | null;
  },
  setIsImageModalOpen: (isImageModalOpen: boolean) => void,
  handleFileUploading: (file: File | null) => void,
  removeProfileImage: () => void,
) => {
  const [profileChanged, setProfileChanged] = useState<boolean>(false);
  const [previewFileData, setPreviewFileData] = useState<{
    previewType: string;
    previewUrl: string | null | undefined;
  }>({
    previewType: "Image",
    previewUrl: null,
  });

  useEffect(() => {
    setPreviewFileData({
      previewType: "Image",
      previewUrl: user.profile_image_url,
    });
  }, [user.profile_image_url]);

  const handleUploadedFile = (file: File | null) => {
    if (file) {
      setProfileChanged(true);
    }
    handleFileUploading(file);
  };

  const manageRemoveProfileImage = () => {
    setIsImageModalOpen(false);

    if (!profileChanged) {
      removeProfileImage();
      return;
    }

    setPreviewFileData({
      previewType: "Image",
      previewUrl: user?.profile_image_url,
    });

    handleFileUploading(null);
    setProfileChanged(false);
  };

  return {
    previewFileData,
    setPreviewFileData,
    handleUploadedFile,
    manageRemoveProfileImage,
  };
};
